var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { aiInspectionManagerPath } from '@routes';
import mapper from './mapper';
export function getSettings() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(aiInspectionManagerPath(), {
                headers: {
                    Accept: 'application/json'
                }
            });
            return response.data;
        }
        catch (error) {
            console.error('Error fetching ai inspection manager settings:', error);
            throw error;
        }
    });
}
export function updateSettings(settings) {
    return __awaiter(this, void 0, void 0, function* () {
        const apiPayload = mapper(settings);
        try {
            yield api.patch(aiInspectionManagerPath(), {
                tenant: apiPayload
            });
        }
        catch (error) {
            console.error('Error updating ai inspection manager:', error);
            if (error &&
                typeof error === 'object' &&
                'response' in error &&
                error.response &&
                typeof error.response === 'object' &&
                'status' in error.response &&
                'data' in error.response &&
                error.response.status === 422 &&
                error.response.data &&
                typeof error.response.data === 'object' &&
                'errors' in error.response.data &&
                typeof error.response.data.errors === 'string') {
                throw new Error(error.response.data.errors);
            }
            throw error;
        }
    });
}
export function updateTechnicianIaModeOverride(technicianId, iaModeOverride) {
    return __awaiter(this, void 0, void 0, function* () {
        /* eslint-disable @typescript-eslint/naming-convention */
        const payload = { technician: { ia_mode_override: iaModeOverride } };
        /* eslint-enable @typescript-eslint/naming-convention */
        try {
            yield api.patch(`/technicians/${technicianId}.json`, payload);
        }
        catch (error) {
            console.error('Error updating technician ia_mode_override:', error);
            throw error;
        }
    });
}
export function getAvailableInspectionsCount(days) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const path = `${aiInspectionManagerPath()}/available_inspections_count`;
            const response = yield api.get(path, { params: { days } });
            return response.data;
        }
        catch (error) {
            console.error('Error fetching available inspections count:', error);
            throw error;
        }
    });
}
export function queueInspections(days) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const path = `${aiInspectionManagerPath()}/queue_inspections`;
            const response = yield api.post(path, { days });
            return response.data;
        }
        catch (error) {
            console.error('Error queuing inspections:', error);
            throw error;
        }
    });
}
export function publishAll(days) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const path = `${aiInspectionManagerPath()}/publish_all`;
            const response = yield api.post(path, { days });
            return response.data;
        }
        catch (error) {
            console.error('Error publishing inspections:', error);
            throw error;
        }
    });
}
export function getUnpublishedInspectionsCount(days) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const path = `${aiInspectionManagerPath()}/unpublished_inspections_count`;
            const response = yield api.get(path, { params: { days } });
            return response.data;
        }
        catch (error) {
            console.error('Error fetching unpublished inspections count:', error);
            throw error;
        }
    });
}
